import { mapMapMarkers } from '../DataTypes/mapMarkerMapper';

export const mapMap = ({ content, settings }): Content.ContentModule => ({
	documentType: content?.contentType,
	content: {
		properties: {
			mapMarkers: mapMapMarkers(content.properties.mapMarkers.items),
		},
	},
	settings: {
		properties: {
			width: settings.properties.width ?? '',
			height: settings.properties.height ?? '',
		},
	},
});
